import { defaultReportState } from "../state";
import { downloadFileFinishedAction, downloadStaticReportFileAction, downloadFileStateError } from "./actions";

export function downloadReducer(state = defaultReportState.downloadState, action: any) {
    switch (action.type) {
        case downloadStaticReportFileAction.type: {
            return "LOADING";
        }
        case downloadFileFinishedAction.type: {
            return "LOADED";
        }
        case downloadFileStateError.type: {
            return "ERROR";
        }
    }
    return state;
}
